<template>
  <div
    v-if="isShowInterviewMaterial"
    class="material-file-entry"
    @click="goMaterial"
  >
    <img
      class="entry-icon"
      src="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/ssqwxa/interview/interview-notice/icon-files.png"
    />
    <div class="entry-title">下载打印携带</div>
    <div class="entry-action">
      <span>查看资料</span>
      <img
        class="entry-arrow"
        src="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/ssqwxa/interview/interview-notice/icon-right.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionMaterialFile',
  props: {
    interviewData: {
      type: Object,
      default: () => ({}),
    },
    userOrderId: {
      type: Number,
      default: 0,
    },
    orderApplicantId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isShowInterviewMaterial() {
      const interviewData = this.interviewData;
      if (!interviewData) return false;

      const haveApplicantMaterial = (
        interviewData.applicant_material || []
      ).some(
        (applicant) =>
          applicant.material_file_set && applicant.material_file_set.length,
      );

      return haveApplicantMaterial;
    },
  },
  methods: {
    goMaterial() {
      this.$router.push({
        name: 'InterviewMaterial',
        params: {
          orderId: this.userOrderId,
          applicantId: this.orderApplicantId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.material-file-entry {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 50px;
  margin-top: 8px;
  padding: 0 12px;
  background: #fff;

  .entry-icon {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    margin-right: 6px;
  }

  .entry-title {
    flex: 1;
    min-width: 0;
    color: #333;
    font-size: 15px;
    font-weight: 500;
    line-height: 1;
  }

  .entry-action {
    display: flex;
    align-items: center;
    color: #a6a6a6;
    font-size: 12px;
    line-height: 1;
  }

  .entry-arrow {
    width: 12px;
    height: 12px;
    margin-left: 4px;
  }
}
</style>
